import { useQuery } from '@tanstack/react-query';
import { apiFetch } from 'utils/apiUtils.ts';
import { Notification } from 'schemas/Notification.schema.ts';
import featureFlags from 'services/featureFlags.ts';
import { fetchAuthSession } from 'aws-amplify/auth';

export default function useNotifications() {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: async () => {
      const authSession = await fetchAuthSession();
      if (!authSession.tokens) {
        return null;
      }

      return apiFetch<Notification[]>({
        path: 'notifications',
        method: 'GET',
        accessToken: String(authSession.tokens.accessToken),
      });
    },
    refetchInterval: 30_000,
    enabled: featureFlags.notificationsEnabled,
  });
}
